import type { FaireProductEntity } from "../../entity_types/product";

export const p_w5w6293588: FaireProductEntity = {
  token: "p_w5w6293588",
  type: "product",
  name: "Mini Hydrating Peptide Spray Spring Set",
  brandToken: "b_4mwr31tr64",
  brandName: "Timeless Skin Care",
  imageUrl:
    "https://cdn.faire.com/fastly/4fecda0bd29c02769b561b4132b66b2b727cd087281075d16013cdd5a2598921.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4765e64cf0e20e6d1aec962e7fb04149c89c185103d27fa3000cdc7ebef2ea44.png",
    "https://cdn.faire.com/fastly/2cc13419e425ef2999889f1219b40f1a7f8596b389575c8ef41b004378c44241.png",
    "https://cdn.faire.com/fastly/b85eecb9c3264b788e9996e1e3d0b89e554b13d409fc1a0a63e1ed75f05cba95.png",
    "https://cdn.faire.com/fastly/c201c206da64ea5dd4f2a0420960be61021e9403d018e00e5fbfdde90f9b0d7c.png",
    "https://cdn.faire.com/fastly/06d8af42a5f43d982d969b43d9587af982b117b9de9fe36a4b1339255f84e3c6.png",
  ],
  priceDollars: 12.5,
  description:
    "PARABEN FREE | SULFATE FREE | ARTIFICIAL FRAGRANCE | DYE FREE | CRUELTY FREE | VEGAN \n\n\nRefresh, Hydrate, and Glow - Our Limited Edition Mini Peptide Hydrating Sprays Set, expertly crafted with Hyaluronic Acid and Matrixyl® 3000 peptides to deliver deep hydration, boost collagen production, and enhance your skin’s elasticity. These compact, TSA-approved 2oz sprays are your ultimate travel companion for keeping your skin nourished, refreshed, and radiant wherever you go. Plus, the set comes with an exclusive Timeless skincare bag for stylish storage!\n\nIncludes:\n\n * Lavender Mini Peptide + Hyaluronic Acid Spray (2oz) \n * Rose Mini Peptide + Hyaluronic Acid Spray (2oz) \n * Cucumber Mini Peptide + Hyaluronic Acid Spray (2oz)\n\n\nRecommended for: All skin types\n\nTargets: Dehydrated, Dull Skin\n\n\n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:00.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
